var Qt = Object.defineProperty, Et = Object.defineProperties;
var It = Object.getOwnPropertyDescriptors;
var z = Object.getOwnPropertySymbols;
var ut = Object.prototype.hasOwnProperty, ct = Object.prototype.propertyIsEnumerable;
var lt = (i) => {
  throw TypeError(i);
};
var ht = (i, t, e) => t in i ? Qt(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e, w = (i, t) => {
  for (var e in t || (t = {}))
    ut.call(t, e) && ht(i, e, t[e]);
  if (z)
    for (var e of z(t))
      ct.call(t, e) && ht(i, e, t[e]);
  return i;
}, dt = (i, t) => Et(i, It(t));
var ft = (i, t) => {
  var e = {};
  for (var r in i)
    ut.call(i, r) && t.indexOf(r) < 0 && (e[r] = i[r]);
  if (i != null && z)
    for (var r of z(i))
      t.indexOf(r) < 0 && ct.call(i, r) && (e[r] = i[r]);
  return e;
};
var X = (i, t, e) => t.has(i) || lt("Cannot " + e);
var s = (i, t, e) => (X(i, t, "read from private field"), e ? e.call(i) : t.get(i)), p = (i, t, e) => t.has(i) ? lt("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), c = (i, t, e, r) => (X(i, t, "write to private field"), r ? r.call(i, e) : t.set(i, e), e), f = (i, t, e) => (X(i, t, "access private method"), e);
import { aE as Ut, aO as O, aF as Z, aP as K, aQ as Ft, aR as pt, aS as bt, aT as Dt, aU as Tt, aV as Lt, aW as yt, aI as Mt, aX as xt, aY as Pt, aZ as jt, m as At, aJ as kt, aK as Wt, q as B, aL as vt, ax as Nt, aN as gt, aM as _t } from "./define-element-XpjsV6s1.js";
var y, n, N, b, I, P, R, _, j, A, U, F, Q, k, o, W, G, H, $, q, tt, et, st, Ct, Ot, zt = (Ot = class extends Ut {
  constructor(t, e) {
    super();
    p(this, o);
    p(this, y);
    p(this, n);
    p(this, N);
    p(this, b);
    p(this, I);
    p(this, P);
    p(this, R);
    p(this, _);
    p(this, j);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    p(this, A);
    p(this, U);
    p(this, F);
    p(this, Q);
    p(this, k, /* @__PURE__ */ new Set());
    this.options = e, c(this, y, t), c(this, R, null), this.bindMethods(), this.setOptions(e);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (s(this, n).addObserver(this), mt(s(this, n), this.options) ? f(this, o, W).call(this) : this.updateResult(), f(this, o, q).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return it(
      s(this, n),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return it(
      s(this, n),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), f(this, o, tt).call(this), f(this, o, et).call(this), s(this, n).removeObserver(this);
  }
  setOptions(t, e) {
    const r = this.options, u = s(this, n);
    if (this.options = s(this, y).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof O(this.options.enabled, s(this, n)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    f(this, o, st).call(this), s(this, n).setOptions(this.options), r._defaulted && !Z(this.options, r) && s(this, y).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: s(this, n),
      observer: this
    });
    const h = this.hasListeners();
    h && Rt(
      s(this, n),
      u,
      this.options,
      r
    ) && f(this, o, W).call(this), this.updateResult(e), h && (s(this, n) !== u || O(this.options.enabled, s(this, n)) !== O(r.enabled, s(this, n)) || K(this.options.staleTime, s(this, n)) !== K(r.staleTime, s(this, n))) && f(this, o, G).call(this);
    const l = f(this, o, H).call(this);
    h && (s(this, n) !== u || O(this.options.enabled, s(this, n)) !== O(r.enabled, s(this, n)) || l !== s(this, Q)) && f(this, o, $).call(this, l);
  }
  getOptimisticResult(t) {
    const e = s(this, y).getQueryCache().build(s(this, y), t), r = this.createResult(e, t);
    return Kt(this, r) && (c(this, b, r), c(this, P, this.options), c(this, I, s(this, n).state)), r;
  }
  getCurrentResult() {
    return s(this, b);
  }
  trackResult(t, e) {
    const r = {};
    return Object.keys(t).forEach((u) => {
      Object.defineProperty(r, u, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(u), e == null || e(u), t[u])
      });
    }), r;
  }
  trackProp(t) {
    s(this, k).add(t);
  }
  getCurrentQuery() {
    return s(this, n);
  }
  refetch(e = {}) {
    var t = ft(e, []);
    return this.fetch(w({}, t));
  }
  fetchOptimistic(t) {
    const e = s(this, y).defaultQueryOptions(t), r = s(this, y).getQueryCache().build(s(this, y), e);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, e));
  }
  fetch(t) {
    var e;
    return f(this, o, W).call(this, dt(w({}, t), {
      cancelRefetch: (e = t.cancelRefetch) != null ? e : !0
    })).then(() => (this.updateResult(), s(this, b)));
  }
  createResult(t, e) {
    var ot;
    const r = s(this, n), u = this.options, h = s(this, b), l = s(this, I), v = s(this, P), T = t !== r ? t.state : s(this, N), { state: S } = t;
    let d = w({}, S), E = !1, a;
    if (e._optimisticResults) {
      const g = this.hasListeners(), J = !g && mt(t, e), wt = g && Rt(t, r, e, u);
      (J || wt) && (d = w(w({}, d), Lt(S.data, t.options))), e._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: C, errorUpdatedAt: L, status: m } = d;
    if (e.select && d.data !== void 0)
      if (h && d.data === (l == null ? void 0 : l.data) && e.select === s(this, _))
        a = s(this, j);
      else
        try {
          c(this, _, e.select), a = e.select(d.data), a = yt(h == null ? void 0 : h.data, a, e), c(this, j, a), c(this, R, null);
        } catch (g) {
          c(this, R, g);
        }
    else
      a = d.data;
    if (e.placeholderData !== void 0 && a === void 0 && m === "pending") {
      let g;
      if (h != null && h.isPlaceholderData && e.placeholderData === (v == null ? void 0 : v.placeholderData))
        g = h.data;
      else if (g = typeof e.placeholderData == "function" ? e.placeholderData(
        (ot = s(this, A)) == null ? void 0 : ot.state.data,
        s(this, A)
      ) : e.placeholderData, e.select && g !== void 0)
        try {
          g = e.select(g), c(this, R, null);
        } catch (J) {
          c(this, R, J);
        }
      g !== void 0 && (m = "success", a = yt(
        h == null ? void 0 : h.data,
        g,
        e
      ), E = !0);
    }
    s(this, R) && (C = s(this, R), a = s(this, j), L = Date.now(), m = "error");
    const M = d.fetchStatus === "fetching", x = m === "pending", V = m === "error", nt = x && M, at = a !== void 0;
    return {
      status: m,
      fetchStatus: d.fetchStatus,
      isPending: x,
      isSuccess: m === "success",
      isError: V,
      isInitialLoading: nt,
      isLoading: nt,
      data: a,
      dataUpdatedAt: d.dataUpdatedAt,
      error: C,
      errorUpdatedAt: L,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > T.dataUpdateCount || d.errorUpdateCount > T.errorUpdateCount,
      isFetching: M,
      isRefetching: M && !x,
      isLoadingError: V && !at,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: E,
      isRefetchError: V && at,
      isStale: rt(t, e),
      refetch: this.refetch
    };
  }
  updateResult(t) {
    const e = s(this, b), r = this.createResult(s(this, n), this.options);
    if (c(this, I, s(this, n).state), c(this, P, this.options), s(this, I).data !== void 0 && c(this, A, s(this, n)), Z(r, e))
      return;
    c(this, b, r);
    const u = {}, h = () => {
      if (!e)
        return !0;
      const { notifyOnChangeProps: l } = this.options, v = typeof l == "function" ? l() : l;
      if (v === "all" || !v && !s(this, k).size)
        return !0;
      const D = new Set(
        v != null ? v : s(this, k)
      );
      return this.options.throwOnError && D.add("error"), Object.keys(s(this, b)).some((T) => {
        const S = T;
        return s(this, b)[S] !== e[S] && D.has(S);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && h() && (u.listeners = !0), f(this, o, Ct).call(this, w(w({}, u), t));
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && f(this, o, q).call(this);
  }
}, y = new WeakMap(), n = new WeakMap(), N = new WeakMap(), b = new WeakMap(), I = new WeakMap(), P = new WeakMap(), R = new WeakMap(), _ = new WeakMap(), j = new WeakMap(), A = new WeakMap(), U = new WeakMap(), F = new WeakMap(), Q = new WeakMap(), k = new WeakMap(), o = new WeakSet(), W = function(t) {
  f(this, o, st).call(this);
  let e = s(this, n).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (e = e.catch(Ft)), e;
}, G = function() {
  f(this, o, tt).call(this);
  const t = K(
    this.options.staleTime,
    s(this, n)
  );
  if (pt || s(this, b).isStale || !bt(t))
    return;
  const r = Dt(s(this, b).dataUpdatedAt, t) + 1;
  c(this, U, setTimeout(() => {
    s(this, b).isStale || this.updateResult();
  }, r));
}, H = function() {
  var t;
  return (t = typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(s(this, n)) : this.options.refetchInterval) != null ? t : !1;
}, $ = function(t) {
  f(this, o, et).call(this), c(this, Q, t), !(pt || O(this.options.enabled, s(this, n)) === !1 || !bt(s(this, Q)) || s(this, Q) === 0) && c(this, F, setInterval(() => {
    (this.options.refetchIntervalInBackground || Tt.isFocused()) && f(this, o, W).call(this);
  }, s(this, Q)));
}, q = function() {
  f(this, o, G).call(this), f(this, o, $).call(this, f(this, o, H).call(this));
}, tt = function() {
  s(this, U) && (clearTimeout(s(this, U)), c(this, U, void 0));
}, et = function() {
  s(this, F) && (clearInterval(s(this, F)), c(this, F, void 0));
}, st = function() {
  const t = s(this, y).getQueryCache().build(s(this, y), this.options);
  if (t === s(this, n))
    return;
  const e = s(this, n);
  c(this, n, t), c(this, N, t.state), this.hasListeners() && (e == null || e.removeObserver(this), t.addObserver(this));
}, Ct = function(t) {
  Mt.batch(() => {
    t.listeners && this.listeners.forEach((e) => {
      e(s(this, b));
    }), s(this, y).getQueryCache().notify({
      query: s(this, n),
      type: "observerResultsUpdated"
    });
  });
}, Ot);
function Bt(i, t) {
  return O(t.enabled, i) !== !1 && i.state.data === void 0 && !(i.state.status === "error" && t.retryOnMount === !1);
}
function mt(i, t) {
  return Bt(i, t) || i.state.data !== void 0 && it(i, t, t.refetchOnMount);
}
function it(i, t, e) {
  if (O(t.enabled, i) !== !1) {
    const r = typeof e == "function" ? e(i) : e;
    return r === "always" || r !== !1 && rt(i, t);
  }
  return !1;
}
function Rt(i, t, e, r) {
  return (i !== t || O(r.enabled, i) === !1) && (!e.suspense || i.state.status !== "error") && rt(i, e);
}
function rt(i, t) {
  return O(t.enabled, i) !== !1 && i.isStaleByTime(K(t.staleTime, i));
}
function Kt(i, t) {
  return !Z(i.getCurrentResult(), t);
}
function St(i = "") {
  if (!xt())
    throw new Error(
      "vue-query hooks can only be used inside setup() function or functions that support injection context."
    );
  const t = jt(i), e = Pt(t);
  if (!e)
    throw new Error(
      "No 'queryClient' found in Vue context, use 'VueQueryPlugin' to properly initialize the library."
    );
  return e;
}
function Vt(i, t, e) {
  const r = St(), u = At(() => {
    const a = kt(t);
    typeof a.enabled == "function" && (a.enabled = a.enabled());
    const C = r.defaultQueryOptions(a);
    return C._optimisticResults = r.isRestoring.value ? "isRestoring" : "optimistic", C;
  }), h = new i(r, u.value), l = Wt(h.getCurrentResult());
  let v = () => {
  };
  B(
    r.isRestoring,
    (a) => {
      a || (v(), v = h.subscribe((C) => {
        vt(l, C);
      }));
    },
    { immediate: !0 }
  );
  const D = () => {
    h.setOptions(u.value), vt(l, h.getCurrentResult());
  };
  B(u, D), Nt(() => {
    v();
  });
  const T = (...a) => (D(), l.refetch(...a)), S = () => new Promise(
    (a, C) => {
      let L = () => {
      };
      const m = () => {
        if (u.value.enabled !== !1) {
          h.setOptions(u.value);
          const M = h.getOptimisticResult(
            u.value
          );
          M.isStale ? (L(), h.fetchOptimistic(u.value).then(a, (x) => {
            gt(u.value.throwOnError, [
              x,
              h.getCurrentQuery()
            ]) ? C(x) : a(h.getCurrentResult());
          })) : (L(), a(M));
        }
      };
      m(), L = B(u, m);
    }
  );
  B(
    () => l.error,
    (a) => {
      if (l.isError && !l.isFetching && gt(u.value.throwOnError, [
        a,
        h.getCurrentQuery()
      ]))
        throw a;
    }
  );
  const E = _t(l);
  for (const a in l)
    typeof l[a] == "function" && (E[a] = l[a]);
  return E.suspense = S, E.refetch = T, E;
}
function Zt(i, t) {
  return Vt(zt, i);
}
let Y = null;
function Gt() {
  return Y || (Y = St()), Y;
}
export {
  Zt as a,
  St as b,
  Gt as u
};
